import api from './api';
import types from './mutation-types';

export default {
	/**연계 콤보 시작 */
	async getFactoris_({ commit }) {
		try {
			const data = await api.getFactoris();
			if (data.header.code === 0) {
				const { resultList = [] } = data.body;
				//console.log('get factorh :', resultList);
				commit(types.DEFAULT_ASSIGN, { key: 'factoryList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	/**모든 라인을 가져온 후 필요에 따라 getter의 lineList_ 필터링한다. */
	async getLines_({ commit }) {
		try {
			const data = await api.getLines();
			if (data.header.code === 0) {
				const { resultList = [] } = data.body;
				//console.log('get getLines_ :', resultList);
				let result = resultList.map(list => {
					list.ref1Cd = list.ref1Cd.split(',');
					list.ref2Cd = list.ref2Cd.split(',');
					return list;
				});
				await commit(types.DEFAULT_ASSIGN, { key: 'lineList', value: result });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	/**필터된 라인만 가져온다 (자바스크립트로 필터할 수 없다면 사용 추천) */
	async getLinesFiltered_({ state, commit }) {
		try {
			const { cdDesc } = state.searchParams.comm;
			const data = await api.getLinesFiltered(cdDesc);
			if (data.header.code === 0) {
				const { resultList } = data.body;
				await commit(types.DEFAULT_ASSIGN, { key: 'lineFilteredList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	async getTestInfo_({ state, commit }) {
		try {
			const { gqmsSeq } = state;
			const data = await api.selectOne(gqmsSeq);
			if (data.header.code === 0) {
				//console.log('getTestInfo action ::', data.body);
				const { resultData, fileList } = data.body;

				await commit(types.DEFAULT_ASSIGN, { key: 'resultObj', value: resultData });
				await commit(types.DEFAULT_ASSIGN, { key: 'resultFileList', value: fileList });
				//console.log('actions :::state >', state);
			} else if (data.header.code === 3) {
			}
		} catch (error) {
			return error.header || error;
		}
	},
	//이미지를 보여주기 위한 다운로드
	async imgDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload({ params });
			const filename = decodeURIComponent(response.headers.filename);
			const filetype = decodeURIComponent(filename.substring(filename.lastIndexOf('.') + 1));
			let url = '';
			if ('|JPG|PNG|GIF|'.indexOf(filetype.toUpperCase()) > -1)
				url = window.URL.createObjectURL(new Blob([response.data], { type: 'image/png' }));
			return { name: filename, url };
		} catch (error) {
			return error.header || error;
		}
	},

	//실제 파일명을 클릭했을때 다운로드 하기 위한 함수
	async fileDownload_(store, params = { fileId, fileSeq }) {
		try {
			const response = await api.fileDownload(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error.header || error;
		}
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	SetFactoryList({ commit }, { key, value }) {
		commit(types.FACTORY_LIST, { key, value });
	},
	setLineList_({ commit }, { key, value }) {
		commit(types.LINE_LIST, { key, value });
	},
	setCommCode_({ commit }, { key, value }) {
		commit(types.COMM_CODE, { key, value });
	},
	setSaveDataObj3_({ commit }, { saveData }) {
		commit(types.DEFAULT_ASSIGN, { key: 'saveDataObj3', value: saveData });
	},

	//freeform 내용저장
	saveFreeForm_({ state, commit }) {
		const formData = new FormData();
		//console.log('4. saveFreeForm_ 수행', state.resultObj);
		// formData.append('gqmsSeq', this.pprNo);

		// 이미지 이외의 내용 append
		//console.log('resObj >>> ', state.resultObj);
		//console.log('4-1. resultObj_ 수행');
		Object.keys(state.resultObj).forEach(key => formData.append(key, state.resultObj[key]));
		// formData.append('gqmsSeq', state.resultObj['gqmsSeq']);
		// formData.append('imgId1', state.resultObj['imgId1']);
		// formData.append('imgId2', state.resultObj['imgId2']);
		// formData.append('fileId', state.resultObj['fileId']);
		// formData.append('file2Id', state.resultObj['file2Id']);

		// const resObj = this.resultObj_;
		// Object.keys(this.resultObj_).forEach(key => console.log(key, this.resultObj_[key]));
		//console.log('4-2. getSaveDataObj3_ 수행', state.saveDataObj3);
		formData.set('gqmsTitle', state.saveDataObj3['title']);
		formData.set('gqmsConts', state.saveDataObj3['conts']);
		// Object.keys(this.getSaveDataObj3_).forEach(key => formData.append(key, this.getSaveDataObj3_[key]));
		//Object.keys(state.saveDataObj3).forEach(key => formData.append(key, state.saveDataObj3[key]));

		// 이미지 파일관련 form append
		//console.log('5.this.getSaveDataObj3_[imgFile1]', state.saveDataObj3['imgFile1']);
		if (state.saveDataObj3['imgFile1']) formData.set('imgFile1', state.saveDataObj3['imgFile1']);
		else formData.set('imgFile1', '');

		// 이미지 파일관련 form append
		//console.log('6.this.getSaveDataObj3_[imgFile2]', state.saveDataObj3['imgFile2']);
		if (state.saveDataObj3['imgFile2']) formData.set('imgFile2', state.saveDataObj3['imgFile2']);
		else formData.set('imgFile2', '');
		//console.log(formData);

		// return false;
		return api
			.saveFreeForm({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},
	// freeForm단건 삭제
	deleteFreeForm_(state, param) {
		return api
			.deleteFreeForm(param)
			.then(data => {
				if (data.header.code == 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				throw error;
			});
	}
};
